// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "b0fca029ff8aed36f1a753dd973a3d0b" + ".js";
};